import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-coupon_btn_down",
  "use": "icon-coupon_btn_down-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-coupon_btn_down\"><path d=\"m4 10.5c-.128 0-.256-.049-.354-.146-.195-.195-.195-.512 0-.707l3.672-3.672-3.672-3.673c-.195-.195-.195-.512 0-.707s.512-.195.707 0l3.849 3.849c.142.142.22.331.22.531s-.078.389-.221.53l-3.848 3.848c-.097.098-.225.147-.353.147zm3.495-4.349h.01z\" fill=\"#999\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coupon_btn_down.svg
// module id = qg9b
// module chunks = 87